import React from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation, Routes, Route } from 'react-router-dom';
import NotFoundPage from '../../containers/NotFoundPage';
import LoginPage from '../../containers/LoginPage';
import RegisterPage from '../../containers/RegisterPage';
import Constants from '../../submodules/logictry_config/constants';
import SettingsPage from '../../containers/SettingsPage';
import CompanySettingsPage from '../../containers/CompanySettingsPage';
import EmailPage from '../../containers/EmailPage';
import ResetPasswordPage from '../../containers/ResetPasswordPage';
import Navigation from '../../services/Navigation';
import NotificationPage from '../../containers/NotificationsPage';
import Company from '../../services/Company';
import WindowSize from '../../services/WindowSize';
import UserAccount from '../../services/UserAccount';
import DrawerService from '../../services/Drawer';
import TreeAnswerPage from '../../containers/TreeAnswerPage';
import TreeEditPage from '../../containers/TreeEditPage/index';
import TreePage from '../../containers/TreePage';
import ExportPage from '../../containers/ExportPage';
import SpreadsheetPage from '../../containers/SpreadsheetPage';
import DatabasePage from '../../containers/DatabasePage';
import DatabaseCollectionPage from '../../containers/DatabaseCollectionPage';
import TeamPage from '../../containers/TeamPage/index';
import TemplateProjectsPage from '../../containers/TemplateProjectsPage/index';
import CompanyBillingPage from '../../containers/CompanyBillingPage/index';
import RegisterCompany from '../../containers/RegisterPage/RegisterCompany';
import LandingPage from '../../containers/LandingPage/index';
import AppLandingPage from '../../containers/AppLandingPage';
import LoginToViewPage from '../../containers/LoginToViewPage';
import NotAuthorizedPage from '../../containers/NotAuthorizedPage';
import Legal from './legalroutes';
import Header from '../../components/Header';
import Drawer from '../../components/Drawer';

const DesktopWrapper = styled.div`
  display: flex;
  position: absolute;
  bottom: 0px;
  right: 0px;
  left: 0px;
  > div:last-child {
    position: relative;
  }
`;

function MainRoutes() {
  Navigation.useNavigate = useNavigate();
  Navigation.location = useLocation();
  const { isSalesForce, isApp, isWidget } = Constants;

  if (isWidget) return (
    <Routes key={window.location.href}>
      <Route path="apps/:id" element={<TreeAnswerPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
  if (['login', 'register', 'reset-password'].includes(Navigation.currentLocation[1])) {
    if (UserAccount.isLoggedIn) setTimeout(() => { Navigation.replace(Navigation.home); });
  }

  const { open } = DrawerService;
  const { mobile } = WindowSize;
  const { isAuthorizedToLogIn } = Company;
  const { isLoggedIn } = UserAccount;
  const showCompanyRoutes = isLoggedIn && Company.isExpected && isAuthorizedToLogIn;
  const showHeader = ((isApp || isSalesForce) && (!UserAccount.isLoggingIn));
  const showDrawer = showHeader && isLoggedIn && open;
  return (
    <>
      {showHeader && <Header fixed={isLoggedIn} />}
      <DesktopWrapper style={{ top: showHeader ? Constants.DesktopHeaderHeight : 0 }}>
        <div style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: showDrawer && !mobile ? 240 : 0 }}>
          <Routes key={`${window.location.pathname}${window.location.search}${JSON.stringify(Navigation.location.state)}`}>
            <Route path="account/notifications" element={isLoggedIn && <NotificationPage /> || <LoginToViewPage />} />
            <Route path="account/settings" element={isLoggedIn && <SettingsPage /> || <LoginToViewPage />} />
            <Route path="apps/:id" element={<TreeAnswerPage />} />
            <Route path="apps/:id/analytics" element={isLoggedIn && <TemplateProjectsPage /> || <LoginToViewPage />} />
            <Route path="apps/:id/edit" element={isLoggedIn && (isAuthorizedToLogIn && <TreeEditPage /> || <NotAuthorizedPage />) || <LoginToViewPage />} />
            <Route path="apps/:id/export" element={isLoggedIn && (isAuthorizedToLogIn && <ExportPage /> || <NotAuthorizedPage />) || <LoginToViewPage />} />
            {showCompanyRoutes && <Route path="company/billing" element={<CompanyBillingPage />} />}
            {showCompanyRoutes && <Route path="company/settings" element={<CompanySettingsPage />} />}
            <Route path="databases/:id" element={isLoggedIn && (isAuthorizedToLogIn && <DatabasePage /> || <NotAuthorizedPage />) || <LoginToViewPage />} />
            <Route path="databasecollections/:id" element={isLoggedIn && (isAuthorizedToLogIn && <DatabaseCollectionPage /> || <NotAuthorizedPage />) || <LoginToViewPage />} />
            <Route path="feedback" element={<AppLandingPage app="60de191f9146e50896bd87f2" />} />
            <Route path="legal" element={<AppLandingPage app="5f38503f916d230a6bdf43a2" />} />
            {Legal.map(({ url, app }) => (
              <Route key={url} path={`legal/${url}`} element={<AppLandingPage app={app} />} />
            ))}
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="register-company" element={isLoggedIn && (isAuthorizedToLogIn && <RegisterCompany /> || <NotAuthorizedPage />) || <LoginToViewPage />} />
            <Route path="reset-password" element={<ResetPasswordPage />} />
            <Route path="spreadsheets/:id" element={isLoggedIn && (isAuthorizedToLogIn && <SpreadsheetPage /> || <NotAuthorizedPage />) || <LoginToViewPage />} />
            {showCompanyRoutes && <Route path="teams/:id" element={<TeamPage />} />}
            <Route path="templates" element={<AppLandingPage app="6357e561bb34735df70674e9" />} />
            <Route path="unsubscribe" element={<EmailPage />} />
            <Route path="tutorials" element={<AppLandingPage app="6351498f2ba65e349b54912f" />} />
            <Route path="videos" element={<AppLandingPage app="5f444323d2070b7f59ae76bb" />} />
            <Route path="/" element={isLoggedIn && <TreePage /> || <LandingPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
        {showDrawer && <Drawer key={`${window.location.pathname}${window.location.search}${JSON.stringify(Navigation.location.state)}`} />}
      </DesktopWrapper>
    </>
  );
}

export default MainRoutes;
